import angular from 'angular';
import errorReportComponent from './errorReport.component';
import ErrorReportService from './errorReport.service';

let errorReportModule = angular.module('errorReport', [])
  .component('errorReport', errorReportComponent)
  .service('errorReportService', ErrorReportService);

export default errorReportModule;



// WEBPACK FOOTER //
// ./app/components/errorReport/errorReport.js